// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1g3Jn","lastUpdated":"TermsOfService_lastUpdated__2DKI9"};